import { Controller } from 'react-hook-form';

import Checkbox from '../../../../../../components/Checkbox/Checkbox';
import { TOPIC } from '../../../../../../constants/formFields';

import type IStandardTopicsItem from '../../../../../../store/slices/survey/interfaces/IStandardTopicsItem';
import type { ISurveyAnswerPrioritiseTopicProps } from '../interfaces/ISurveyAnswerPrioritiseTopic';

import styles from './scss/TopicCheckboxList.module.scss';

function PrioritiseTopicCheckboxList({
  control,
  standardTopicsData,
}: ISurveyAnswerPrioritiseTopicProps) {
  return (
    <div className={styles.topicsContainer}>
      <Controller
        control={control}
        name={TOPIC}
        defaultValue={[]}
        render={({ field: { value = [], onChange } }) => (
          <>
            {standardTopicsData.map((topic: IStandardTopicsItem) => (
              <div key={topic.id}>
                <Checkbox
                  name={`topic-${topic.id}`}
                  value={topic.id.toString()}
                  checked={Array.isArray(value) && value.includes(topic.id)}
                  className={styles.topics}
                  label={(
                    <span>
                      <strong>
                        {topic.standard.name}
                        {' '}
                        Topic
                      </strong>
                      {' '}
                      -
                      {' '}
                      {topic.title}
                    </span>
                  )}
                  onChange={(event) => {
                    const { checked } = event.target;
                    const currentValue = Array.isArray(value) ? value : [];
                    if (checked) {
                      if (!currentValue.includes(topic.id)) {
                        onChange([...currentValue, topic.id]);
                      }
                    } else {
                      onChange(currentValue.filter((id: number | undefined) => id !== topic.id));
                    }
                  }}
                />
              </div>
            ))}
          </>
        )}
      />
    </div>
  );
}

export default PrioritiseTopicCheckboxList;
